async function d(t, r) {
  if (!r)
    throw new Error("Filename is required to get download URL");
  try {
    return await t.getFileDownloadUrl(r);
  } catch (e) {
    const o = e instanceof Error ? e.message : "Failed to get download URL";
    throw console.error(`Failed to get download URL for file ${r}:`, o), e;
  }
}
async function s(t, r) {
  return r.length === 0 ? [] : (await Promise.allSettled(
    r.map((o) => d(t, o))
  )).map((o, n) => {
    const l = r[n];
    if (o.status === "fulfilled")
      return {
        filename: l,
        url: o.value
      };
    {
      const a = o.reason instanceof Error ? o.reason.message : "Failed to get download URL";
      return console.error(`Failed to get download URL for file ${l}:`, o.reason), {
        filename: l,
        url: "",
        error: a
      };
    }
  });
}
export {
  d as getCopilotFileDownloadUrl,
  s as getCopilotFilesDownloadUrls
};
